import * as React from 'react';

import { style } from './RecommendationSection';
import { __, replacePlaceholders } from '../../helpers/TranslationService';
import { CalendarIcon } from '../Icons/CalendarIcon';
import { FlightIcon } from '../Icons/FlightIcon';
import { ShipIcon } from '../Icons/ShipIcon';

interface IProps {
    nights: number;
    includesFlight: boolean;
}

export const CruiseRecommendationDescRoundtrip = (props: IProps) => {
    const roundtripDaysText = replacePlaceholders(__('%s days (roundtrip page)', 'dreamlines'), [
        props.nights,
    ]);
    return (
        <div style={style.cardInfo}>
            <div style={style.spacingBottom}>
                <CalendarIcon width={18} height={18} style={style.iconStyle} />
                <span className="overflow-ellipsis--single-line" style={style.teaserText}>
                    {roundtripDaysText}
                </span>
            </div>
            {props.includesFlight ? (
                <div style={style.spacingBottom}>
                    <FlightIcon width={18} height={18} style={style.iconStyle} />
                    <span className="overflow-ellipsis--single-line" style={style.teaserText}>
                        {__('Flight included', 'dreamlines')}
                    </span>
                </div>
            ) : null}
            <div style={style.spacingBottom}>
                <ShipIcon width={18} height={18} style={style.iconStyle} />
                <span className="overflow-ellipsis--single-line" style={style.teaserText}>
                    {__('Includes cruise', 'dreamlines')}
                </span>
            </div>
        </div>
    );
};
